import React from "react";

// Wraps text inside `{}` with <em> to apply italic styling.
export const formatTitle = (title) => {
	if (!title) return null;
	const parts = title.split(/({.*?})/g); 
	
	return parts.map((part, index) => 
		part.startsWith("{") && part.endsWith("}") ? (
			<em key={index}>{part.slice(1, -1)}</em>
		) : (
			part
		)
	);
};